import type { TFunction } from 'i18next'

import { productUnitCodeToTranslationKey } from '../constants/productUnitCodeToTranslationKey'
import type { ProductUnit } from '../types/productUnit'
import { getProductUnitCode } from './getProductUnitCode'
import { isProductUnitCode } from './isProductUnitCode'

export const getProductUnitFullName = (unit: ProductUnit, t: TFunction): string | undefined => {
  const code = getProductUnitCode(unit)
  const translationKey = code && isProductUnitCode(code) ? productUnitCodeToTranslationKey[code] : undefined

  return translationKey ? t(translationKey) : undefined
}
